import * as moment from "moment";
import { put, select, takeLatest } from "redux-saga/effects";
import {
    GetPatientInfoResponse,
    TypeOfFinalTransaction,
    ErrorCodes,
    GetPatientInfo,

    InteractionType,
    UpdatePatientInfoResponse,
    HealthCardAcquisitionType
} from "../../dtos/KioskDtos.dtos";
import Client from "../../services/Client";
import TimerManager from "../../services/TimerManager";
import {
    incrementNumberOfSubmitAttempts,
} from "../../store/AcquireHealthCardNumber/actions";
import {
    getHealthCardExpirationRedirectToReceptionValueForSaga,
    getOptionAbleToSeeAndModifyExistingPatientDataForSaga
} from "../../store/AdminOptions/selectors";
import { showErrorUpdateMessage } from "../../store/Errors/actions";
import { disconnectKeyboard } from "../../store/Keyboard/actions";
import {
    finishedGettingPatientDataFromServerSaga
} from "../ApplicationAsyncSagas/sagas";
import {
    GET_PATIENT_INFO,
    PUT_PATIENT_INFO
} from "./constant";
import {
    GetPatientInfoFromServerAction,
    PutPatientInfoToServerAction
} from "./types";
import { toggleNetworkLoadingSpinnerVisibility } from "../../store/LoadingSpinner/actions";
import { errorHandlerSaga, expectedErrorHandlerSaga } from "../errorSaga";
import { redirectToSurvey } from "../surveyRedirectSaga";
import { getPatientAppointmentsFromServer } from "../Appointments/actions";
import { debugDispatchSaga } from "../debugDispatchSaga";


export function* getPatientInfoFromServerRequestSaga(action: GetPatientInfoFromServerAction) {
    yield TimerManager.stopInactivityListener();
    yield put(incrementNumberOfSubmitAttempts("healthCardNumberOfAttempts"));
    yield put(toggleNetworkLoadingSpinnerVisibility(true));
    yield put(disconnectKeyboard());
    try {
        yield debugDispatchSaga("Health Card Scanned", false, { HealthCardNumber: action.payload.healthCardNumber, AcquisitionMethod: HealthCardAcquisitionType[action.payload.acquisitionType] });
        const response: GetPatientInfoResponse = yield Client.getPatientInfo(new GetPatientInfo({ healthCardNumber: action.payload.healthCardNumber, acquisitionType: action.payload.acquisitionType }));
        const numberOfPatientsFound = response.numberOfPatientsFound;
        yield debugDispatchSaga("Number of patients found", false, { numberOfPatientsFound });
        if (numberOfPatientsFound === 0) {
            yield expectedErrorHandlerSaga(ErrorCodes.NoPatientsFound);
        } else if (numberOfPatientsFound > 1) {
            yield expectedErrorHandlerSaga(ErrorCodes.MultiplePatientsFound);
        } else {
            const patientInfo = response.patientIndividualInformation;
            const expiryDate = patientInfo.healthCard.expiryDate;
            const previousMonth = moment().utc().add(-1, "month");
            const isDate = expiryDate && moment(expiryDate).isValid();
            if (
                !(yield select(getHealthCardExpirationRedirectToReceptionValueForSaga))
                || (isDate && moment(yield patientInfo.healthCard.expiryDate).utc().isAfter(previousMonth, "month"))
            ) {
                yield finishedGettingPatientDataFromServerSaga(patientInfo);
            } else {
                Client.logInteractionEvent(InteractionType.HealthCardExpiredTriggered);
                yield put(redirectToSurvey(showErrorUpdateMessage(true, ErrorCodes.HealthCardExpired, true), TypeOfFinalTransaction.EncounteredError, ErrorCodes.HealthCardExpired));
            }
        }
    } catch (e) {
        yield errorHandlerSaga(e);
    }
    yield put(toggleNetworkLoadingSpinnerVisibility(false));
    yield TimerManager.resetInactivityListener();
}

export function* putPatientInfoToServerSaga(action: PutPatientInfoToServerAction) {
    yield TimerManager.stopInactivityListener();
    yield put(toggleNetworkLoadingSpinnerVisibility(true));
    try {
        if (yield select(getOptionAbleToSeeAndModifyExistingPatientDataForSaga)) {
            yield debugDispatchSaga("Sending Updated Patient Information to MYLE", false);
            const response: UpdatePatientInfoResponse = yield Client.putPatientInfo(action.payload.patientInfo);
            if (response.isSuccessful) {
                yield debugDispatchSaga("Patient Informatipn Update", false, "Successfull");
                yield put(getPatientAppointmentsFromServer(action.payload.patientInfo.patientId));
            } else {
                yield expectedErrorHandlerSaga(ErrorCodes.UnableToUpdatePatientInformation);
            }
        } else {
            yield put(getPatientAppointmentsFromServer(action.payload.patientInfo.patientId));
        }
    } catch (e) {
        yield errorHandlerSaga(e);
    }
    yield TimerManager.resetInactivityListener();
}

export function* watchForAllPatientInfoSagas() {
    yield takeLatest(GET_PATIENT_INFO, getPatientInfoFromServerRequestSaga);
    yield takeLatest(PUT_PATIENT_INFO, putPatientInfoToServerSaga);
}



// WEBPACK FOOTER //
// ./src/sagas/PatientInfo/sagas.ts